import { query, serviceQueries } from '@estee/elc-service-bus';
import { observable } from 'mobx';
import { InStorePickupBanner } from '~domain/entities/InStorePickupBanner';

export interface IImage {
    src: string;
    alt: string;
}

export interface IApptBookingServiceContent {
    image: IImage;
    description: string;
    contentId: string;
    title: string;
}

export class StoreDetailsRepository {
    @observable public inStorePickupBanner: InStorePickupBanner;
    @observable public storeImageExists: boolean = false;

    @observable public servicesTemplatesContent: Map<string, IApptBookingServiceContent> = new Map<
        string,
        IApptBookingServiceContent
    >();
    public loadInStorePickupBannerTemplate = async (nodeId: number) => {
        const inStorePickupBannerTemplate = await query(serviceQueries.TEMPLATES_CONTENT_GET, {
            nodeId
        });
        this.inStorePickupBanner = InStorePickupBanner.fromJson(inStorePickupBannerTemplate[0]);
    };

    public checkStoreImage = async (
        url: string
    ): Promise<{ src: string; storeImageExists: boolean }> => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                this.storeImageExists = true;
                resolve({ src: url, storeImageExists: true });
            };
            img.onerror = () => {
                this.storeImageExists = false;
                resolve({ src: url, storeImageExists: false });
            };
            img.src = url;
        });
    };

    public fetchInStoreServicesTemplateContent = async (nodeId: number) => {
        const templatesContent = <IApptBookingServiceContent[]>(
            await query(serviceQueries.TEMPLATES_CONTENT_GET, { nodeId })
        );
        for (const serviceContent of templatesContent) {
            const { contentId } = serviceContent;

            if (contentId) {
                this.servicesTemplatesContent.set(contentId, serviceContent);
            }
        }
    };
}
